<template>
    <v-layout justify-center>
        <v-responsive max-width="1440px" width="100%" height="100%" class="shop-product-view">
            <div class="headline text-start mt-8">
                <span v-if="user._id">사용자 상세</span>
                <span v-else>사용자 등록</span>
            </div>

            <v-row>
                <v-col cols="12" md="9">
                    <v-card class="mb-2" outlined>
                        <v-card-title class="subtitle-2 font-weight-bold">계정정보</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="user.username" label="아이디" v-bind="attrs_input" readonly />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="user.title" label="회원유형" v-bind="attrs_input" readonly />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="user.password" label="비밀번호" placeholder="비밀번호 변경 시 입력" v-bind="attrs_input" />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field :value="user.createdAt?.toDate?.()" label="가입일" readonly placeholder="비밀번호 변경 시 입력" v-bind="attrs_input" />
                                    <!-- <v-text-field v-model="user.subPassword" label="서브비밀번호" placeholder="비밀번호 변경 시 입력" v-bind="attrs_input" /> -->
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card class="mb-2" outlined>
                        <v-card-title class="subtitle-2 font-weight-bold">기본정보</v-card-title>
                        <v-card-text>
                            <v-row v-if="isOrganization">
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="user.companyName" label="기업명" v-bind="attrs_input" />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="user.businessNumber" label="사업자등록번호" v-bind="attrs_input" />
                                </v-col>
                            </v-row>

                            <v-row v-if="isOrganization">
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="user.ceoName" label="대표자명" v-bind="attrs_input" />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="user.establishedAt" label="기업설립일" v-bind="attrs_input" type="date" />
                                </v-col>
                            </v-row>

                            <v-row v-if="!isOrganization">
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="user.name" label="이름" v-bind="attrs_input" />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="user.affiliation" :label="isStudent ? '학교/학과' : '소속/부서'" v-bind="attrs_input" />
                                </v-col>
                            </v-row>

                            <v-row v-if="isIndividual && !isSupporter">
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="user.bornAt" label="생년월일" v-bind="attrs_input" readonly />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <!-- <v-text-field v-model="user.residentNumber1" label="주민등록번호" v-bind="attrs_input" /> -->
                                </v-col>
                            </v-row>
                            <v-row v-if="isElse">
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="user.gender" label="성별" v-bind="attrs_input" />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="user.region" label="지역" v-bind="attrs_input" />
                                </v-col>
                            </v-row>

                            <v-row v-if="!isSupporter">
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="user.phone" label="연락처" v-bind="attrs_input" />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="user.email" label="이메일" v-bind="attrs_input" />
                                </v-col>
                            </v-row>

                            <v-row v-if="!isSupporter">
                                <v-col cols="12" lg="2">
                                    <v-text-field v-model="user.postcode" label="우편번호" v-bind="attrs_input" readonly @click="$refs.DaumPostcode.open()" />
                                </v-col>
                                <v-col cols="12" lg="">
                                    <v-text-field v-model="user.address1" label="기본주소" v-bind="attrs_input" readonly @click="$refs.DaumPostcode.open()" />
                                </v-col>
                                <v-col cols="12" lg="">
                                    <v-text-field v-model="user.address2" label="상세주소" v-bind="attrs_input" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card class="mb-2" outlined>
                        <v-card-title class="subtitle-2 font-weight-bold">
                            {{ isSupporter ? "자문분야" : "관심분야" }}
                        </v-card-title>
                        <v-card-text>
                            <user-areas v-if="user._areas" v-model="user" :areas="areas" />
                        </v-card-text>
                    </v-card>

                    <v-card class="mb-2" v-if="isSupporter" outlined>
                        <v-card-title class="subtitle-2 font-weight-bold"> 공개정보 </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="5" class="py-0">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field v-model="user.nickname" label="닉네임" v-bind="attrs_input" />
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field v-model="user.phone" label="연락처" v-bind="attrs_input" />
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field v-model="user.email" label="이메일" v-bind="attrs_input" />
                                        </v-col>
                                    </v-row>
                                    <image-input v-model="avatar" label="전문가 사진" :imageSrc="user?.avatar?.url" />
                                </v-col>
                                <v-col cols="7">
                                    <v-textarea v-model="user.summary" label="전문가 소개" v-bind="attrs_input" rows="8" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card class="mb-2" v-if="isOrganization" outlined>
                        <v-card-title class="subtitle-2 font-weight-bold"> 상세정보 </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="5" class="py-0">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field v-model="user.website" label="홈페이지 주소" v-bind="attrs_input" />
                                        </v-col>
                                        <v-col cols="12" lg="">
                                            <v-text-field v-model="user.workerName" label="담당자 이름" v-bind="attrs_input" />
                                        </v-col>
                                        <v-col cols="12" lg="">
                                            <v-text-field v-model="user.workerTitle" label="담당자 직책" v-bind="attrs_input" />
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field v-model="user.mainProduct" label="주요생산제품" v-bind="attrs_input" />
                                        </v-col>
                                    </v-row>
                                    <image-input v-model="avatar" label="기업로고" :imageSrc="user?.avatar?.url" rounded />
                                    <files-input v-model="brochures" label="소개자료" />
                                </v-col>
                                <v-col cols="7">
                                    <v-textarea v-model="user.summary" label="기업소개" v-bind="attrs_input" rows="13" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <user-description v-if="isSupporter || isOrganization" v-model="user" />
                </v-col>

                <v-col cols="12" md="3">
                    <v-card class="mb-2" v-if="isOrganization || isSupporter" outlined>
                        <v-card-title class="subtitle-2 font-weight-bold">계정상태</v-card-title>
                        <v-card-text class="caption primary--text">
                            <v-switch v-model="user.isApproval" label="가입승인" v-bind="attrs_switch" v-if="isSupporter" />
                            <v-switch v-model="user.isExpert" label="전문기업/전문가승인" v-bind="attrs_switch" />
                            <v-switch v-model="user.isDisplayed" label="검색노출" v-bind="attrs_switch" />
                            <v-switch v-model="user.isContactDisplayed" label="연락처노출" v-bind="attrs_switch" style="margin-bottom: 0 !important" />
                            <!-- <v-switch v-model="user.isWarning" label="주의회원" v-bind="attrs_switch" color="red lighten-1" /> * 주의회원 체크시 문자와 메일이 발숭되지 않으니 주의 부탁드립니다 -->
                        </v-card-text>
                    </v-card>

                    <v-card class="mb-2" outlined>
                        <v-card-title class="subtitle-2 font-weight-bold">QR코드</v-card-title>
                        <v-card-text>
                            <qrcode-vue :value="user?._id" :size="103" class="d-flex justify-center pa-4" />
                        </v-card-text>
                    </v-card>

                    <v-card class="mb-2" outlined>
                        <v-card-title class="subtitle-2 font-weight-bold">MES</v-card-title>
                        <v-card-text>
                            <v-switch label="부품조회표기" v-model="user.mes.showsMaterialList" v-bind="attrs_switch" />
                            <v-switch label="일정조회표기" v-model="user.mes.showsScheduleList" v-bind="attrs_switch" />
                        </v-card-text>
                    </v-card>

                    <v-card class="mb-2" outlined>
                        <v-card-title class="subtitle-2 font-weight-bold">관리자 메모</v-card-title>
                        <v-card-text>
                            <v-textarea v-model="user.note" outlined hide-details rows="10" />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-btn fab fixed right bottom color="primary" @click="save" x-large>
                <v-icon x-large>mdi-content-save</v-icon>
            </v-btn>
        </v-responsive>
        <daum-postcode
            ref="DaumPostcode"
            @input="
                ({ postcode, address }) => {
                    user.postcode = postcode;
                    user.address1 = address;
                }
            "
        ></daum-postcode>
    </v-layout>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import { INDIVIDUAL_KINDS, USER_TYPES } from "@/assets/variables";

import QrcodeVue from "qrcode.vue";
import UserAreas from "@/components/console/user/user-areas.vue";
import ImageInput from "@/components/console/dumb/image-input.vue";
import FilesInput from "@/components/console/dumb/files-input.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import UserDescription from "@/components/console/user/user-description.vue";

const attrs_switch = {
    inset: true,
    color: "primary",
    hideDetails: true,
    class: "ma-0 pa-0 mb-3",
};
const attrs_input = {
    dense: true,
    outlined: true,
    persistentpersistentPlaceholder: true,
    hideDetails: true,
};

export default {
    components: {
        QrcodeVue,
        UserAreas,
        ImageInput,
        FilesInput,
        DaumPostcode,
        UserDescription,
    },
    computed: {
        areas() {
            return this.$store?.state?.areas || [];
        },
        areas_structured() {
            const parents = (this.areas || []).filter(({ _parent }) => !_parent).sort((a, b) => a.order - b.order);
            const areas = parents.map((parent) => ({
                ...parent,
                children: (this.areas || []).filter(({ _parent }) => _parent == parent._id).sort((a, b) => a.order - b.order),
            }));
            return areas;
        },
        isIndividual() {
            return this.user?.type == USER_TYPES.INDIVIDUAL;
        },
        isOrganization() {
            return this.user?.type == USER_TYPES.ORGANIZATION;
        },
        isSupporter() {
            return this.user?.kind == "SUPPORTER";
        },
        isStudent() {
            return this.user?.kind == "STUDENT";
        },
        isElse() {
            return this.user?.kind == "ELSE";
        },
    },
    data() {
        return {
            levels: [],
            user: {
                _id: this.$route.params._user,
                type: null,
                kind: null,
                mes: {},
            },
            avatar: null,
            brochures: [],
            attrs_switch,
            attrs_input,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            if (this.user._id) {
                var {
                    user: { bornAt, establishedAt, ...user },
                } = await api.console.users.get({ _id: this.$route.params._user });

                if (bornAt) bornAt = bornAt.toDate();
                if (establishedAt) establishedAt = establishedAt.toDate();

                this.user = {
                    ...user,
                    bornAt,
                    establishedAt,
                };

                if (user?.avatar?.url) this.avatar = await api.getResource(user?.avatar?.url, true);

                if (user?.brochures) this.brochures = await Promise.all((user?.brochures || [])?.map(async ({ url }) => api.getResource(url, true)));
            }

            var { levels } = await api.console.levels.gets();
            this.levels = levels;
        },

        validate() {
            try {
                return true;
            } catch (error) {
                alert(error.message);
            }
            return false;
        },

        async save() {
            if (this.validate()) {
                const _user = this.user._id;

                if (this.user?._avatar) {
                    await api.console.users.avatar.delete({ _id: this.user._avatar, _user });
                }

                for (const _id of this.user?._brochures || []) {
                    await api.console.users.brochures.delete({ _id, _user });
                }

                if (this.user._id) {
                    await api.console.users.put({
                        ...this.user,
                        password: this.user.password ? CryptoAES.encrypt(this.user.password) : undefined,
                        _avatar: undefined,
                        avatar: undefined,
                        _brochures: undefined,
                        brochures: undefined,
                    });
                } else {
                    await api.console.users.post({
                        ...this.user,
                        username: this.user.email,
                        password: this.user.password ? CryptoAES.encrypt(this.user.password) : undefined,
                        _avatar: undefined,
                        avatar: undefined,
                        _brochures: undefined,
                        brochures: undefined,
                    });
                }

                if (this.avatar) {
                    await api.console.users.avatar.post({ _user }, this.avatar);
                }

                if (this.brochures?.length) {
                    for (const [index, brochure] of this.brochures.entries()) {
                        await api.console.users.brochures.post({ _user, index }, brochure);
                    }
                }

                alert("저장되었습니다");
                this.$router.push(`/console/users`);
            }
        },
    },
};
</script>
